// Seasonal maintenance checklist + curated videos.
import type { VideoItem } from '@/shared/components/VideoGrid.vue'

export interface TipGroup {
    season: string
    icon: string
    tips: string[]
}

export const TIP_GROUPS: TipGroup[] = [
    {
        season: 'Spring',
        icon: '🌱',
        tips: [
            'Change the filter before cooling season starts',
            'Hose off the outdoor coil (power off first) and clear 2 ft of clearance around it',
            'Flush the condensate drain with a cup of white vinegar',
            'Run the AC once on a warm day — find problems in April, not July',
        ],
    },
    {
        season: 'Summer',
        icon: '☀️',
        tips: [
            'Check the filter monthly — cooling season loads it fastest',
            'Keep supply vents open, even in unused rooms',
            'Watch the outdoor unit: ice or constant running deserve attention early',
            'Set humidity expectations: 30–50% indoors is the healthy band',
        ],
    },
    {
        season: 'Fall',
        icon: '🍂',
        tips: [
            'Book heating service before the first cold snap (the calendar fills fast)',
            'Test the heat once while it’s still mild out',
            'Replace thermostat batteries and check the schedule',
            'Clear leaves off and around the outdoor unit',
        ],
    },
    {
        season: 'Winter',
        icon: '❄️',
        tips: [
            'Keep the filter fresh — heat needs airflow too',
            'Don’t block returns with furniture or holiday decor',
            'If you run a humidifier, target 30–40% to avoid window condensation',
            'Heat pumps: light frost on the outdoor coil is normal; ice buildup is not',
        ],
    },
]

export const VIDEOS: VideoItem[] = [
    {
        id: 'OvBIlG6pYl0',
        title: 'How to change your HVAC air filter',
        blurb: 'The 2-minute habit that prevents half of all cooling failures. (WIN Home Inspection)',
    },
    {
        id: '_M-JLzIQHtk',
        title: 'Clean your condenser coil, step by step',
        blurb: 'A garden hose and 20 minutes can noticeably improve cooling. (AmplifyDIY)',
    },
    {
        id: 'sL8LJnKaul0',
        title: 'Unclog your AC drain line with vinegar',
        blurb: 'Stop the most common cause of AC water leaks for under $3. (CreativeProcessDIY)',
    },
    {
        id: '-33wjzNxgSw',
        title: 'How to repair a frozen air conditioner',
        blurb: 'Why coils ice up and what to do about it. (Ask This Old House)',
    },
    {
        id: 'FaDG_t32XYs',
        title: 'How experts troubleshoot an AC system',
        blurb: 'Watch a pro work the same checklist our guides teach. (Ask This Old House)',
    },
    {
        id: 'EAsPUvpvDUE',
        title: 'HVAC maintenance checklist for homeowners',
        blurb: 'The full seasonal routine in one video. (HomeMembership)',
    },
]
